module.exports = __webpack_public_path__ + "img/rocket_transparent.93ec9b39.png";